import { logger } from '@/helpers/logger';
import { useQuery } from '@tanstack/react-query';
import type { Asset } from '@uikit/types';

const fetchAsset = async (path: string | undefined) => {
  if (!path) {
    return null;
  }

  try {
    const response = await fetch(path);
    const data: object = await response.json();

    return data;
  } catch (error) {
    logger.error(`Failed to load lottie animation data from ${path}`, error);
    return null;
  }
};

export const useLottieAsset = (asset: Asset | undefined) => {
  const path = asset?.path;

  return useQuery({
    queryKey: ['lottie-asset', { path }],
    queryFn: () => fetchAsset(path),
    staleTime: Infinity,
    enabled: !!path,
  });
};
